module.exports = __webpack_public_path__ + "static/media/intro-bg-mask.97db50e5.png";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/intro-bg-mask.png
// module id = 406
// module chunks = 0